import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { propTypes, reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { Notification, translate, userLogin } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import packageJson from '../../package.json';
import indigo from "@material-ui/core/colors/indigo";

const styles = theme => ({
    main: {
      backgroundColor: '#f1f1f1',
      height: '100vh',
      width: '100%'
    },
    form: {
      margin: '1em'
    },
    logo: {
      margin: '20px',
      textAlign: 'center'
    },
    logoImg: {
      marginRight: '10px',
      width: '30px',
      verticalAlign: 'bottom'
    },
    logoTitle: {
      fontSize: '32px',
      color: indigo['500'],
      fontFamily: 'Rajdhani, sans-serif',
      display: 'inline-block',
      lineHeight: '28px'
    },
    gridColumTitle: {
      fontSize: '30px',
      fontWeight: 'normal',
      maxWidth: '340px',
      color: '#999',
      fontFamily: 'Rajdhani, sans-serif'
    },
    gridColumSubTitle: {
      fontFamily: 'Rajdhani, sans-serif'
    },
    marginBlock: {
      margin: '1em'
    },
    field: {
      marginBottom: '1em',
      width: '100%'
    },
    circular: {
      marginRight: '5px'
    },
    small: {
      background: '#fff',
      boxShadow: '0px 0px 32px -13px rgba(0,0,0,0.61)',
      padding: '0.3em 0.5em',
      margin: '2em'
    }
});

const renderInput = ({
    meta: { touched, error } = {},
    input: { ...inputProps },
    ...props
}) => (
    <TextField
        error={!!(touched && error)}
        helperText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />
);





class Login extends Component {
    login = auth =>
        this.props.userLogin(
            auth,
            this.props.location.state
                ? this.props.location.state.nextPathname
                : '/'
        );

    Titulo = (props, color) => {
      const { classes } = this.props;
      return (
        <div className={classes.marginBlock}>
          <Typography variant="headline" className={classes.gridColumSubTitle}>{process.env.REACT_APP_SUB_TITLE}</Typography>
          <Typography variant="title" className={classes.gridColumTitle}>{process.env.REACT_APP_TITLE}</Typography>
        </div>
      )
    }

    Formulario = props => {
      const { classes, handleSubmit, isLoading, translate } = this.props;
      return (
        <form className={classes.form} onSubmit={handleSubmit(this.login)}>
          <FormControl fullWidth={true}>
            <Field
              name="username"
              component={renderInput}
              label="Usuario o D.N.I."
              disabled={isLoading}
              className={classes.field}
            />
            <Field
              name="password"
              component={renderInput}
              label={translate('ra.auth.password')}
              type="password"
              disabled={isLoading}
              className={classes.field}
            />

            <Button
              variant="raised"
              type="submit"
              color="primary"
              disabled={isLoading}
              size="large"
              className={classes.field}
              fullWidth
            >
              {isLoading && (
                <CircularProgress size={25} thickness={2} className={classes.circular} />
              )}
              Ingresar
            </Button>
          </FormControl>
          <Notification />
          <Typography
            variant="caption"
            display="block"
            className={classes.field}
          >
            Versión: { packageJson.version }
          </Typography>
        </form>
      )
    }

    render() {
        const { classes } = this.props;
        return (

              <Grid container
                justify="center"
                direction="column"
                alignItems="center"
                className={classes.main}
              >
                <Grid item>
                    <div className={classes.logo}>
                      <img src="/images/launcher-icon-1x.png"  className={classes.logoImg} alt="Recuperadores" />
                      <Typography className={classes.logoTitle}>_RECUPERADORES</Typography>
                    </div>
                    <div className={classes.small} >
                      {this.Titulo(this.props)}
                      {this.Formulario(this.props)}
                    </div>
                </Grid>
              </Grid>

        );
    }
}

Login.propTypes = {
    ...propTypes,
    authProvider: PropTypes.func,
    classes: PropTypes.object,
    previousRoute: PropTypes.string,
    translate: PropTypes.func.isRequired,
    userLogin: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({ isLoading: state.admin.loading > 0 });

const enhance = compose(
    translate,
    reduxForm({
        form: 'signIn',
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;
            if (!values.username) {
                errors.username = translate('ra.validation.required');
            }
            if (!values.password) {
                errors.password = translate('ra.validation.required');
            }
            return errors;
        },
    }),
    connect(
        mapStateToProps,
        { userLogin }
    ),
    withStyles(styles)
);

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/layout/Login.js